import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import DotsLoader from '../../../../../../../common/components/dotsLoader/DotsLoader';
import elementLoaderStyles from './elementLoaderStyles';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const ElementLoaderWrapper: FC = ({ children }) => {
  const styles = elementLoaderStyles();
  const { loading } = useCustomizeCarContext();

  if (loading) {
    return (
      <Grid item={true} md={6} xs={5} className={styles.loader}>
        <DotsLoader />
      </Grid>
    );
  }

  return <>{children}</>;
};

export default ElementLoaderWrapper;
